<template>
    <el-dialog custom-class="dialog" class="measDialog" append-to-body :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="50%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="开始时间" prop="starttime">
                    <el-time-picker v-model="form.starttime" value-format="HH:mm" format="HH:mm" placeholder="请选择">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endtime">
                    <el-time-picker v-model="form.endtime" value-format="HH:mm" format="HH:mm" placeholder="请选择">
                    </el-time-picker>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveTimeconfig">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { saveTimeconfig } from '@/api/measApi/systemManage.js'
export default {
  data() {
    return {
      form: {
        code: '',
        endtime: '',
        starttime: ''
      },
      rules: {
        starttime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endtime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      visible: false,
      isLoading: false,
      title: '新增时段',
      orgForm: {}
    }
  },
  methods: {
    handleOpen(row) {
      this.visible = true

      this.orgForm = JSON.parse(JSON.stringify(this.form))
      if (row) {
        this.form = JSON.parse(JSON.stringify(row))
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    saveTimeconfig() {
      this.$refs.form.validate(validate => {
        if (validate) {
          this.isLoading = true
          saveTimeconfig(this.form).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.$emit('saveSuccess')
              this.isLoading = false
              this.handleClose()
            }
          })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  transform: none;
  left: 0;
  position: relative;
  margin: 0 auto;
  &.dialog {
    height: 50%;
    overflow: hidden;
    top: 20% !important;
    margin-top: unset !important;
  }
  .el-dialog__body {
    padding: 15px 0 0;
    height: calc(100% - 126px);
    box-sizing: border-box;
    .dialogScroll {
      height: 100%;
      padding-bottom: 1px;
      box-sizing: border-box;
      & > .el-scrollbar__wrap {
        overflow-y: scroll;
        overflow-x: hidden;
        padding: 0 20px;
        height: 100%;
        width: calc(100% + 17px);
        box-sizing: border-box;
      }
    }
  }
}
</style>

